import client from './client';

export default (url: string, status: number | null, err: any | null) => {
    console.log('Unable to fetch location', {
        url: url,
        context: 'BetPlacePage#fetchLocation',
        status: status,
        error: err,
    });
    client.error('Unable to fetch location', {
        url: url,
        context: 'BetPlacePage#fetchLocation',
        status: status,
        error: err,
    });
};
